import * as yup from 'yup'

export const schema = yup.object().shape({
    codeOne: yup.number()
        .required(),
    codeTwo: yup.number()
        .required(),
    codeThree: yup.number()
        .required()
})